/* eslint import/no-webpack-loader-syntax: 0 */

import React, { useEffect } from 'react'
import { setTitle } from '../config';

import { Link } from 'react-router-dom';

import error404Svg from '../images/404.svg';

const Page404 = () => {
  useEffect(() => {
    setTitle("404");
  }, []);

  return (
    <React.Fragment>
      <style dangerouslySetInnerHTML={{
        __html: `
        #header, footer {
          display: none;
        }
        #main-content {
          background-image:none !important;
          background: #FE9268 !important;
        }
      `}} />
      <div id="not-found">
        <img src={error404Svg} id="error-404" alt="404 Page not found!" />
        <h3>
          The page you were looking for could not be found!
        </h3>
        <Link to="/">
          <button className="due-landing__dorito-btn">
            Home
          </button>
        </Link>
      </div>
    </React.Fragment>
  );

}

export default Page404;
